import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

export const useSearchDebounce = (initialValue = '', delay = 500) => {
  const [searchQuery, setSearchQuery] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  const debouncedUpdate = debounce((value: string) => {
    setDebouncedValue(value);
  }, delay);

  useEffect(() => {
    if (searchQuery === '') {
      // Immediate update when clearing search
      setDebouncedValue('');
      debouncedUpdate.cancel();
    } else {
      debouncedUpdate(searchQuery);
    }

    return () => {
      debouncedUpdate.cancel();
    };
  }, [searchQuery, debouncedUpdate]);

  return {
    searchQuery,
    debouncedValue,
    setSearchQuery
  };
};